export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: "dianying",
    name: "电影",
    icon: "ri-movie-2-line",
    description: "最新热门电影，涵盖动作、喜剧、爱情、科幻等类型大片，高清画质畅享观影体验",
    count: 12850,
  },
  {
    slug: "dianshiju",
    name: "电视剧",
    icon: "ri-tv-2-line",
    description: "热播电视剧全集在线观看，国产剧、韩剧、美剧、日剧一网打尽，每日同步更新",
    count: 9630,
  },
  {
    slug: "zongyi",
    name: "综艺",
    icon: "ri-emotion-laugh-line",
    description: "热门综艺节目在线观看，真人秀、脱口秀、音乐竞技、户外挑战精彩不断",
    count: 5420,
  },
  {
    slug: "dongman",
    name: "动漫",
    icon: "ri-ghost-line",
    description: "日漫、国漫、欧美动画全收录，热血、治愈、搞笑、奇幻类型丰富，追番必备",
    count: 8760,
  },
  {
    slug: "jilupian",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "精品纪录片在线观看，自然、历史、科技、人文题材，探索世界的精彩与奥秘",
    count: 3210,
  },
  {
    slug: "tiyu",
    name: "体育",
    icon: "ri-basketball-line",
    description: "精彩体育赛事直播与回放，足球、篮球、网球、F1等全球顶级赛事全覆盖",
    count: 4180,
  },
  {
    slug: "yinyue",
    name: "音乐",
    icon: "ri-music-2-line",
    description: "热门MV、演唱会、音乐节目在线观看，流行、摇滚、古典、电子音乐应有尽有",
    count: 2950,
  },
  {
    slug: "youxi",
    name: "游戏",
    icon: "ri-gamepad-line",
    description: "热门游戏实况、赛事直播、攻略解说，主机游戏、PC游戏、手游资讯一应俱全",
    count: 3670,
  },
];